<form class="modal-body" [formGroup]="form" (ngSubmit)="next()" novalidate>
  <ng-container *ngIf="currentStep === ModalStep.mfaType">
    <p class="centermodal__title">{{ 'mfaModal.titles.type' | translate }}</p>
    <p class="centermodal__description text-left pt-2">{{ 'mfaModal.descriptions.type' | translate }}</p>

    <div class="centermodal__form">
      <label class="field__holder radio-option" *ngFor="let item of mfaOptions">
        <input type="radio" name="mfaType" formControlName="mfaType" [value]="item.type" />
        {{ item.description | translate }}
      </label>
    </div>
  </ng-container>

  <ng-container *ngIf="currentStep === ModalStep.setup">
    <p class="centermodal__title">{{ 'mfaModal.titles.setup' | translate }}</p>
    <p class="centermodal__description text-left pt-2">{{ 'mfaModal.descriptions.setup' | translate }}</p>

    <div class="text-center">
      <qrcode [width]="250" [qrdata]="totp.qr_code" [elementType]="'svg'"></qrcode>
    </div>

    <div class="link-box">
      <a href="javascript:void(0)" (click)="currentStep = ModalStep.setupAlt">{{ 'mfaModal.buttons.manualCode' | translate }}</a>
    </div>
  </ng-container>

  <ng-container *ngIf="currentStep === ModalStep.setupAlt">
    <p class="centermodal__title">{{ 'mfaModal.titles.setup' | translate }}</p>
    <p class="centermodal__description text-left pt-2">{{ 'mfaModal.descriptions.setupAlt' | translate }}</p>

    <div class="copy-box" (click)="copyToClipboard(totp.secret)">{{ totp.secret }}</div>

    <div class="link-box">
      <a href="javascript:void(0)" (click)="currentStep = ModalStep.setup">{{ 'mfaModal.buttons.scanQRCode' | translate }}</a>
    </div>
  </ng-container>

  <ng-container *ngIf="currentStep === ModalStep.confirm">
    <p class="centermodal__title">{{ 'mfaModal.titles.confirm' | translate }}</p>
    <p class="centermodal__description text-left pt-2">{{ 'mfaModal.descriptions.confirm' | translate }}</p>

    <label class="field__holder mb-5" [appFormControlWrap]="form.get('otpCode')">
      <input type="tel" class="field" formControlName="otpCode" name="otpCode" autocomplete="one-time-code" maxlength="6" appOnlyNumbers required />
      <span class="field__placeholder">{{ 'auth.confirmCode' | translate }}</span>
    </label>
  </ng-container>

  <ng-container *ngIf="currentStep === ModalStep.recoveryCode">
    <p class="centermodal__title">{{ 'mfaModal.titles.recoveryCode' | translate }}</p>
    <p class="centermodal__description text-left pt-2">{{ 'mfaModal.descriptions.recoveryCode' | translate }}</p>

    <div class="copy-box mb-5" (click)="copyToClipboard(recoveryCode)">{{ recoveryCode }}</div>
  </ng-container>

  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled-cancel" [class.d-none]="currentStep === ModalStep.recoveryCode" [disabled]="isLoading" (click)="back()">
      {{ 'button.back' | translate }}
    </button>
    <button type="submit" class="btn-L btn-filled d-flex ml-auto" [disabled]="isLoading">
      {{ 'button.' + (currentStep === ModalStep.recoveryCode ? 'finish' : 'forward') | translate }}
    </button>
  </div>
</form>
